import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import storeConfig from './store'

import './App.css';
import Home from './components/Home';
import LogIn from './components/auth/LogIn';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import ForgotPasswordVerification from './components/auth/ForgotPasswordVerification';
import ChangePassword from './components/auth/ChangePassword';
import ChangePasswordConfirm from './components/auth/ChangePasswordConfirm';
import Welcome from './components/auth/Welcome';
import Footer from './components/Footer';
import LogOut from './components/auth/LogOut';
import LotteryIndex from './components/Lottery/LotteryIndex';
import LotteryForm from './components/Lottery/LotteryForm';
import MarketplaceIndex from './components/Marketplace/MarketplaceIndex';
import MarketplaceForm from './components/Marketplace/MarketplaceForm';
import UsuarioIndex from './components/Usuario/UsuarioIndex';
import UsuarioForm from './components/Usuario/UsuarioForm';
import TicketIndex from './components/Ticket/TicketIndex';
import TicketForm from './components/Ticket/TicketForm';
import RewardIndex from './components/Reward/RewardIndex';
import RewardForm from './components/Reward/RewardForm';
import CheckForm from './components/Ticket/CheckForm'
import GeneratorIndex from './components/Generator/GeneratorIndex'
import GeneratorForm from './components/Generator/GeneratorForm';
class App extends Component {
  render() {
    const { store, persistor } = storeConfig();
    return (
      <Provider store={store}>
        <PersistGate loading={(<div>Cargando...</div>)} persistor={persistor}>
          <div className="App">
            <Router>
              <div>
                {/*<Navbar />*/}
                <Switch>
                  <Route exact path="/" component={Home} />
                  <Route exact path="/login" component={LogIn} />
                  <Route exact path="/logout" component={LogOut} />
                  <Route exact path="/register" component={Register} />
                  <Route exact path="/forgotpassword" component={ForgotPassword} />
                  <Route exact path="/forgotpasswordverification" component={ForgotPasswordVerification} />
                  <Route exact path="/changepassword" component={ChangePassword} />
                  <Route exact path="/changepasswordconfirmation" component={ChangePasswordConfirm} />
                  <Route exact path="/welcome" component={Welcome} />
                  <Route exact path="/users" component={UsuarioIndex} />
                  <Route exact path="/users/:id/edit" component={() => <UsuarioForm />} />
                  <Route exact path="/marketplaces" component={MarketplaceIndex} />
                  <Route exact path="/marketplaces/new" component={() => <MarketplaceForm />} />
                  <Route exact path="/marketplaces/:id/edit" component={() => <MarketplaceForm />} />
                  <Route exact path="/lotteries" component={LotteryIndex} />
                  <Route exact path="/lotteries/new" component={() => <LotteryForm />} />
                  <Route exact path="/lotteries/:id/edit" component={() => <LotteryForm readOnly={true} />} />
                  <Route exact path="/tickets" component={TicketIndex} />
                  <Route exact path="/tickets/new" component={() => <TicketForm />} />
                  <Route exact path="/tickets/:id/edit" component={() => <TicketForm readOnly={true} />} />
                  <Route exact path="/rewards" component={RewardIndex} />
                  <Route exact path="/rewards/new" component={() => <RewardForm />} />
                  <Route exact path="/rewards/:id/edit" component={() => <RewardForm readOnly={true} />} />
                  <Route exact path="/marketplaces/lotteries/tickets/:code" component={CheckForm} />
                  <Route exact path="/generators" component={GeneratorIndex} />
                  <Route exact path="/generators/:id/edit" component={() => <GeneratorForm readOnly={true} />} />
                  <Route exact path="/generators/new" component={() => <GeneratorForm />} />

                </Switch>
                <Footer />
              </div>
            </Router>
          </div>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
